import styled, { css } from 'styled-components';

import { VacationRequestType } from '@/utils/enums';

const Badge = styled.span<{ $type: VacationRequestType }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 100px;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;

  ${({ $type, theme }) =>
    $type === VacationRequestType.Paid
      ? css`
          background: ${theme.colors.successLight};
          color: ${theme.colors.success};
        `
      : css`
          background: ${theme.colors.grayscaleLight};
          color: ${theme.colors.gray};
        `}
`;

interface Props {
  type: VacationRequestType;
}

const VacationTypeBadge = ({ type }: Props) => {
  return (
    <Badge $type={type}>
      {type === VacationRequestType.Paid ? 'Paid' : 'Unpaid'}
    </Badge>
  );
};

export default VacationTypeBadge;
